import { NavLink } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import { ReactComponent as Bg } from '@assets/img/menu/menu-hover.svg';
import classnames from 'classnames';
import { useAppSelector } from 'redux/store/store.types';

import ListItem from '@material-ui/core/ListItem';

/* Styles */
import css from './appNav.module.sass';

const SideBarItem = ({ to, label, onClick = () => {}, active = false, className, IconComponent, ...props }) => {
  return (
    <ListItem
      button
      className={classnames(
        'bg-appDark160',
        css.item,
        className ? className : '',
        active ? '!text-appThemeTextColor' : '',
      )}
    >
      <NavLink to={to} onClick={onClick}>
        {active && <Bg className={css.activeMenuBg} />}
        <div className="w-[60px] flex items-center justify-center" onClick={onClick}>
          {props?.icon && <props.icon />}
        </div>
        <p>{label}</p>
        {IconComponent && <IconComponent className={css.icon} />}
      </NavLink>
    </ListItem>
  );
};

export default SideBarItem;
